import { render, staticRenderFns } from "./needLogin.vue?vue&type=template&id=bb6eda28&"
import script from "./needLogin.vue?vue&type=script&lang=js&"
export * from "./needLogin.vue?vue&type=script&lang=js&"
import style0 from "./needLogin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports